import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useMeetingViewerAuth } from "./useMeetingViewerAuth";

export function MeetingViewerAuthGate({ children }: { children: ReactNode }) {
  const { id: productId } = useParams();
  const authStatus = useMeetingViewerAuth();

  if (authStatus === "login" && productId) {
    return <Navigate to={`/meetings/${productId}/login`} replace />;
  }

  // Session auth is already enforced before join; do not unmount the meeting UI while
  // re-validating or autoplay / WebRTC video attachment can fail silently.
  return <>{children}</>;
}
